import axios from "axios";
import router from "@/router";
import BASE_URL from "@/services/baseUrl";
import { refresh } from "@/services/authApi";

const api = axios.create({
  baseURL: `${BASE_URL}`,
});

let isRefreshing = false;
let refreshSubscribers = [];
let latestToken = null;

function subscribeTokenRefresh(cb) {
  if (latestToken) {
    cb(latestToken);
  } else {
    refreshSubscribers.push(cb);
  }
}

function onRefreshed(token) {
  latestToken = token;
  refreshSubscribers.forEach((cb) => cb(token));
  refreshSubscribers = [];
}

api.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem("access_token");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const { response, config } = err;

    // если токен протух
    if (response && response.status === 401 && !config._retry) {
      config._retry = true;

      try {
        if (!isRefreshing) {
          isRefreshing = true;

          const refreshToken = localStorage.getItem("refresh_token");
          const data = await refresh(refreshToken);

          if (data && data.payload && data.payload.access_token) {
            const newAccessToken = data.payload.access_token;

            localStorage.setItem("access_token", newAccessToken);

            isRefreshing = false;
            onRefreshed(newAccessToken);
          } else {
            throw new Error("No access_token in refresh response");
          }
        }

        // возвращаем промис, который резолвится, когда refresh завершится
        return new Promise((resolve, reject) => {
          subscribeTokenRefresh((token) => {
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
              resolve(api(config));
            } else {
              reject(err);
            }
          });
        });
      } catch (e) {
        // если refresh не удался
        isRefreshing = false;
        onRefreshed(null); // всем подписчикам сказать, что не получилось

        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        router.push({ name: "login" });

        return Promise.reject(e);
      }
    }

    return Promise.reject(err);
  }
);

export default api;
export const qboxApi = axios.create({
  baseURL: `https://inqbox.q19.kz`,
});
